import { combineReducers } from "redux";

import order from "../features/admin/order_management/order/Slice"

const orders = combineReducers({

  order: order,
});

export default orders;
